module.exports = __webpack_public_path__ + "static/media/webIcon.41733e77.png";